<template>
    <div>
        <vs-card class="p-4" id="passwordForm">
            <section class="p-4">
                <h4 class="text-2xl mb-2">Sécurité</h4>
                <h6 class="text-muted text-xs mb-6">Si vous souhaitez changer de mot de passe, complétez ce
                    formulaire</h6>
                <div class="vx-row mb-2 items-start">
                    <div class="vx-col sm:w-4/12 lg:3/12 xxl:w-2/12 w-full py-3">
                        <span>Changer de mot de passe</span>
                    </div>
                    <div class="vx-col sm:w-4/12 w-full">
                        <password v-model="passForm.password" name="password" class="w-full"
                                  placeholder="mot de passe" @change="validatePassword"/>
                        <div v-if="!validate_regex">
                            <span class="text-danger text-sm">Le mot de passe doit contenir au moins 8 caractères,
                                dont une majuscule, une minuscule, un chiffre et un caractère spécial</span>
                        </div>
                    </div>
                    <div class="vx-col sm:w-4/12 w-full">
                        <vs-input
                            :disabled="!passForm.password"
                            :success="passForm.password != '' && passForm.password_confirmation === passForm.password"
                            :danger="passForm.password != '' && passForm.password_confirmation !== passForm.password"
                            danger-text="Les mot de passe ne correspondent pas"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            type="password"
                            class="w-full"
                            val-icon-success="icon-check"
                            v-model="passForm.password_confirmation"
                            placeholder="Resaisir le mot de passe"/>
                    </div>
                </div>
            </section>
            <div slot="footer">
                <vs-row vs-justify="flex-end" class="pb-10">
                    <vs-button :disabled="formError && !validate_regex" @click="onUpdatePassword()" type="border" color="primary"
                               icon-pack="feather" icon="icon-save">
                        Enregistrer
                    </vs-button>
                </vs-row>
            </div>
        </vs-card>
    </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'

import {formValidationMixins} from '@/mixins/formValidationMixins.js'
import Password from 'vue-password-strength-meter'

export default {
    name: 'UserPasswordForm',
    mixins: [formValidationMixins],
    components: {
        Password
    },
    data() {
        return {
            passForm: {
                password: '',
                password_confirmation: ''
            },
            validate_regex: false,
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/
        }
    },
    computed: {
        ...mapState({
            userLoading: state => state.user.userLoading,
            activeUser: state => state.user.activeUser,
            formError() {
                return (
                    this.isInvalid(this.passForm.password, 'password') ||
                    this.isInvalid(this.passForm.password_confirmation, 'password') ||
                    this.passForm.password !== this.passForm.password_confirmation
                )
            }
        }),
        validatePassword() {
            this.validate_regex = this.regex.test(this.passForm.password)
        }
    },
    created() {
        this.refreshUserId()
    },
    methods: {
        ...mapActions('user', ['getUser', 'changePassword']),
        refreshUserId() {
            this.getUser(this.activeUser.id).then(() => {
                this.passForm.id = this.activeUser.id
            })
        },
        onUpdatePassword() {
            if (!this.formError) {
                this.changePassword(this.passForm).then(() => {
                    this.passForm.password = this.passForm.password_confirmation = ''
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
